import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  Paper
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const blReportDetails = this.props.blReportDetails;
    const displayedMonthColumns = this.props.displayedMonthColumns;
    const selectedSearchValues = this.props.selectedSearchValues;

    const cellStyle = {
      border: '1px solid #ccc',
      padding: '4px',
      fontSize: '7px',
    };

    const tableContainerStyle = {
      width: '1050px',
      overflowX: 'auto',
    };

    const formatNumber = (value) => {
      return parseFloat(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const startDate = new Date(selectedSearchValues.startDate);
    const endDate = new Date(selectedSearchValues.endDate);
    const startMonth = startDate.toLocaleString('default', { month: 'long' });
    const startYear = startDate.getFullYear();
    const endMonth = endDate.toLocaleString('default', { month: 'long' });
    const endYear = endDate.getFullYear();

    return (
      <div>
        <h2><center>BL Advance Report</center></h2>
        <div>&nbsp;</div>
        <h3><center>{selectedSearchValues.groupName} - {selectedSearchValues.factoryName}</center></h3>
        <div>&nbsp;</div>
        <h3><center>Route: {selectedSearchValues.routeID == undefined ? 'All Route' : selectedSearchValues.routeID}</center></h3>
        <div>&nbsp;</div>
        <h3><center>Start Month: {startMonth} {startYear} - End Month: {endMonth} {endYear}</center></h3>
        <div>&nbsp;</div>

        <div>&nbsp;</div>
        <div>
          <Box>
            <TableContainer component={Paper} style={tableContainerStyle}>
              <Table aria-label="caption table" size="small" style={{ minWidth: '100%' }}>
                <TableHead>
                  <TableRow style={{ border: '1px solid #ccc' }}>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Reg No
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Name
                    </TableCell>

                    <TableCell
                      align="center"
                      colSpan={displayedMonthColumns.length}
                      style={{ ...cellStyle, fontWeight: 'bold' }}
                    >
                      Month
                    </TableCell>

                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Total QTY
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Average QTY
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Loan Balance
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Current Balance
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Request Amount
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Supervisor Approve
                    </TableCell>
                    <TableCell align="center" rowSpan={2} style={cellStyle}>
                      Manager Approve
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    {displayedMonthColumns.map((month, index) => (
                      <TableCell key={index} align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>
                        {month}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {blReportDetails.map((data, index) => {
                    const nonZeroMonths = Object.entries(data.monthlyCropWeights || {}).filter(([month, weight]) => weight > 0);
                    const totalQty = nonZeroMonths.reduce((sum, [month, weight]) => sum + weight, 0);
                    const avgQty = nonZeroMonths.length > 0 ? totalQty / nonZeroMonths.length : 0;

                    return (
                      <TableRow key={index} style={{ border: '1px solid #ccc' }}>
                        <TableCell align="left" style={cellStyle}>
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell align="left" style={cellStyle}>
                          {data.name}
                        </TableCell>

                        {displayedMonthColumns.map((month, idx) => (
                          <TableCell key={idx} align="right" style={cellStyle}>
                            {formatNumber(data.monthlyCropWeights?.[month] ?? '0')}
                          </TableCell>
                        ))}

                        <TableCell align="right" style={cellStyle}>
                          {formatNumber(totalQty)}
                        </TableCell>
                        <TableCell align="right" style={cellStyle}>
                          {formatNumber(avgQty)}
                        </TableCell>
                        <TableCell align="right" style={cellStyle}>
                          {formatNumber(data.loanBalance)}
                        </TableCell>
                        <TableCell align="right" style={cellStyle}>
                          {formatNumber(data.currentBalance)}
                        </TableCell>
                        <TableCell align="center" style={cellStyle}></TableCell>
                        <TableCell align="center" style={cellStyle}></TableCell>
                        <TableCell align="center" style={cellStyle}></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h3><center>***** End of List *****</center></h3>
      </div>
    );
  }
}      

